
import { Parallax } from 'react-parallax';
import { HashLink } from "react-router-hash-link";
import ImageGallery from 'react-image-gallery';

import "react-image-gallery/styles/css/image-gallery.css"; //this is required by gallery

export default function AboutDiva() {
  const photosIndices = [1, 2, 3, 4, 5, 6];
  let images = [];
  for (let i in photosIndices) {
    images.push({
      original: `photos/diva/${photosIndices[i]}.jpg`,
      thumbnail: `photos/diva/small${photosIndices[i]}.jpg`
    })
  }

  return (
    <div>

      <Parallax strength={300} bgImage="photos/diva/6.jpg">
        <div className="section no-pad-bot">

          <div className="container ">
            <h1 className="header center text-lighten-2">Diva</h1>
            <div className="row">
              <div className="col l6 s12 dark-bg">
                <p>Diva yra pirmoji kalytę iš mūsų veislyno, kurią pasilikome sau tolimesniam vados
                  pratęsimui. Tik gimus, iš keturių šuniukų (dvi kalytės ir du patinėliai), ji buvo pati stambiausia ir
                  didžiausia, pralenkė net vados patinėlius. Priešingai nei jos mama (Sierra), ši mergina yra ilgesnė ir
                  atletiškesnė, bendras bruožas- abi priklauso vidutiniai svorio kategorijai. Charakteris bei
                  temperamentas taip pat labai skiriasi nuo mamos, Diva yra tikra nenuorama, jos visur pilna, ji visur

                  dalyvauja, niekada nepraleis progos kieme iškasti duobę ar per tvorą pasiginčyti su kaimynų šunimis.
                  Tai yra labai greitas iš šoklus šuo, dėl to dažnai ją vadiname stirna, ji visur atbėgs pirma, kitoms mūsų
                  kalytėms nepaliks jokių šansų ją aplenkti. Diva noriai laiką leidžia lauke, žaidžia su kamuoliuku bei ypač
                  mėgsta būti glostoma ir kasoma, tačiau tik žmonių kuriuos ji pažįsta bei kuriais pasitiki. Su svetimais ir
                  nepažįstamais ji yra labai atsargi, pradžioje nesileis glostoma, šalinsis, bet tik iki kol supras, jog tai geras
                  žmogus ir juo galima pasitikėti, kitaip tariant, Divos pasitikėjimą reikia užsitarnauti, o tada ji bus pats
                  meiliausias šuo, nenulips nuo kelių ir vis prašysis būti glostoma.
                </p>
                <p>Pirma Divos vada numatoma 2023 metais. Iki tol aktyviai dalyvausime parodose bei atliksime reikiamus
                  med. tyrimus kad įsitikinti nepriekaištinga kalytės sveikata.
                </p>
                <p>Dėl būsimų šuniukų vados prašau <HashLink to="#kontaktai">susisiekite su mumis.</HashLink></p>
              </div>
            </div>
          </div>
        </div>
      </Parallax>

      <div className="container">
        <div className="row center">
          <h2>Divos galerija</h2>
        </div>
        <div className="row center">
          <ImageGallery items={images} slideInterval={2000} />
        </div>
        <a href="/docs/diva.pdf" target="_blank" rel="noopener noreferrer">Kilmės dokumentas.</a>
      </div>

    </div>
  );

}
